/**
 * TRAVEL-MAP-STAYS-TRANSPORT-INTEGRATION-01
 * 住宿／交通與旅程地圖的 logistics 輔助（純函式）。
 * Transport 現有 contract 僅有文字端點摘要，不得產假座標 Marker。
 */
import { MARKER_KIND_ACTIVITY, MARKER_KIND_STAY } from './journeySpatialMarkerModel';

/** 地圖圖層：活動／住宿（client 可見性；不改 API）。 */
export const SPATIAL_LAYER_ACTIVITY = 'activity';
export const SPATIAL_LAYER_STAY = 'stay';

export const DEFAULT_SPATIAL_LAYERS = Object.freeze({
  [SPATIAL_LAYER_ACTIVITY]: true,
  [SPATIAL_LAYER_STAY]: true,
});

export function markerKindLabel(kind) {
  return kind === MARKER_KIND_STAY ? '住宿' : '活動';
}

export function markerKindShortLabel(kind) {
  return kind === MARKER_KIND_STAY ? '宿' : '活';
}

/**
 * 依圖層開關過濾已建好的 map markers；不 mutate 來源。
 */
export function filterMarkersBySpatialLayers(markers, layers = DEFAULT_SPATIAL_LAYERS) {
  const list = Array.isArray(markers) ? markers : [];
  const showActivity = layers?.[SPATIAL_LAYER_ACTIVITY] !== false;
  const showStay = layers?.[SPATIAL_LAYER_STAY] !== false;
  return list.filter((marker) => {
    const kind = marker?.kind || MARKER_KIND_ACTIVITY;
    if (kind === MARKER_KIND_STAY) return showStay;
    return showActivity;
  });
}

/**
 * Transport → 文字型 logistics 列；永不附 lat／lng。
 * 來源為 normalizeTransportSummary／Detail 形狀。
 */
export function buildTransportLogisticsRows(transports) {
  const list = Array.isArray(transports) ? transports : [];
  return list
    .map((item) => {
      const transportId = item?.transportId == null || item.transportId === ''
        ? ''
        : String(item.transportId);
      if (!transportId) return null;
      const sourceLabel = String(item.sourceLabel || '').trim() || '未設定出發地';
      const destinationLabel = String(item.destinationLabel || '').trim() || '未設定目的地';
      return {
        transportId,
        transportModeLabel: item.transportModeLabel || item.transportMode || '未選擇',
        sourceLabel,
        destinationLabel,
        departureDisplay: item.departureDisplay || '',
        arrivalDisplay: item.arrivalDisplay || '',
        carrierText: item.carrierText || '',
        bookingReference: item.bookingReference || '',
        // 明確標記：現有 API 無座標，地圖不畫 pin
        hasCoordinates: false,
        mapPinAvailable: false,
      };
    })
    .filter(Boolean);
}

export function countTransportLogisticsRows(rows) {
  return Array.isArray(rows) ? rows.length : 0;
}
